import {Component, OnInit, OnChanges, Input} from '@angular/core';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {Router, ActivatedRoute} from '@angular/router';
import {DataHandlerService} from '../../../services/data-handler.service';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: [],
    standalone: true,
    imports: [MatCardModule, MatCardModule, NgIf, MatButtonModule, MatButtonModule]
})
export class ConfirmationComponent extends WizardWidgetComponent implements OnInit, OnChanges {
  @Input() public applicationData: any;
  @Input() public baseform: any;
  @Input() public storageIdentifier: any;
  public applicationId: any;
  public isSubmitted = false;
  public redirectTo: String; // URL to get redirected to

  constructor(public dataHandlerService: DataHandlerService,
              private router: Router,
              private activatedRoute: ActivatedRoute) {
    super(dataHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.activatedRoute.queryParams.subscribe((p) => {
      console.debug('ConfirmationComponent.activatedRoute.queryParams');
      if (p.redirect) {
        this.redirectTo = p.redirect;
      }
    });

  }

  ngOnChanges(changes) {
    // check if application data is not empty
    if (changes['applicationData'] && this.applicationData) {
      if (this.applicationData['applicationIds'] && this.applicationData['applicationIds'].length > 0) {
        // get the first one
        this.applicationId = this.applicationData['applicationIds'][0];
        this.isSubmitted = true;
      } else {
        // case where submitted, but deferred
        this.isSubmitted = true;
        this.applicationId = null;
      }
      this.resetForm();
    }
  }

  public redirect() {
    if (!this.isSubmitted) {
      // if form was not submitted go back to previous page
      const prevStep = parseInt(sessionStorage.getItem(this.storageIdentifier + '-step'), 10) - 1;
      sessionStorage.setItem(this.storageIdentifier + '-step', prevStep.toString());
    }
    window.top.postMessage({applicationId: this.applicationId}, '*');
    if (this.redirectTo) {
      console.log('Redirecting to ', this.redirectTo);
      setTimeout(() => {
        (window as any).top.location.href = this.redirectTo;
      }, 500);
    } else {
      this.router.navigate(['/']);
    }
  }

  private resetForm() {
    sessionStorage.removeItem(this.storageIdentifier);
    sessionStorage.removeItem(this.storageIdentifier + '-step');
    sessionStorage.removeItem(this.storageIdentifier + '-step-latest');
    if (sessionStorage.getItem(this.storageIdentifier + '-lead')) {
      sessionStorage.removeItem(this.storageIdentifier + '-lead');
    }
    if (sessionStorage.getItem('partial-data')) {
      sessionStorage.removeItem('partial-data');
    }
  }
}
